import {Component, Inject, Input} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {PanelMountRegistrationStepRoutes, PanelMountRegistrationStepTitles} from "../data/panel-mount-registration-step-routes";
import {PanelMountRegistrationManager, PanelMountRegistrationStatus} from "../services/panel-mount-registration-manager";

@Component({
	selector: "panel-mount-registration-progress-bar",
	template: `
		<!---------- WIZARD STEPS - PROGRESS BAR ---------->
		<div *ngIf="shouldDisplay" class="warrantyregistration_progress_bar hidden-mobileonly">
			<div *ngFor="let step of stepTitles; index as i" class="progress_bar-tab" [class.progress_bar-selected]="currStep === i"
				[class.progress_bar-available]="i <= maxStep" (click)="goToStep(i)">
				<h3 class="progress_bar-header">{{ step }}</h3>
				<hr class="progress_bar-divider">
			</div>
		</div>
	`,
})
export class PanelMountRegistrationProgressBarComponent {
	stepTitles = Object.values(PanelMountRegistrationStepTitles); // Array of all the titles to the different steps
	@Input() currStep: number; // Current step we are on
	@Input() maxStep: number; // Maximum step that we have reached
	isDealerUser: boolean; // If dealer, show Customer Information step

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private manager: PanelMountRegistrationManager,
		@Inject("isDealerUser") isDealerUser: boolean,
	) {
		this.isDealerUser = isDealerUser;
		this.stepTitles = this.stepTitles.filter(title => title !== PanelMountRegistrationStepTitles.STEP_ONE || this.isDealerUser);
	}

	// Routes user to the given path
	//  @param index The index of the StepRoute that we wish to route to
	goToStep(index: number) {
		if (index <= this.maxStep && index !== this.currStep) { // Only go if we have already been to this step & it isn't the current step
			let goToIndex: number = (this.isDealerUser) ? index : index + 1;
			if (!this.isDealerUser && goToIndex === 1) {
				goToIndex = 0;
			}
			this.router.navigate([Object.values(PanelMountRegistrationStepRoutes)[(goToIndex)]],
				{relativeTo: this.route});
		}
	}

	get shouldDisplay(): boolean {
		return this.manager.status === PanelMountRegistrationStatus.NOT_SUBMITTED ||
			this.manager.status === PanelMountRegistrationStatus.SUBMITTED_WITH_ERRORS;
	}
}
